module.exports = __webpack_public_path__ + "static/media/breadcrumb_carrot.f0d42ff5.svg";